import { useState } from 'react';
import moment from 'moment';
import I18n from '../../../config/i18n';
import GoogleTagManagerNg from '../../../features/tracking/GoogleTagManagerNg';
import { CPLStartAvailabilityFormEvent } from '../../../features/tracking/types';
import AvailabilityForm from './AvailabilityForm';
import { CalendarEntryWithDate } from '../../availabilityWidget/api/bookingsApi';
import { createGenerateLeadEvent } from '../../../features/tracking/eventCreators';
import { Accommodation, Property } from '../../../routes/reducers/types';

import './AvailabilityRequest.css';

function trackFormSubmit(accommodation: Accommodation, property: Property): void {
  GoogleTagManagerNg.trackEvent(createGenerateLeadEvent(accommodation, property));
}

interface AvailabilityRequestProps {
  accommodation: Accommodation;
  property: Property;
  minDate: moment.Moment;
  bookings: CalendarEntryWithDate;
}

export default function AvailabilityRequest({
  accommodation,
  property,
  minDate,
  bookings,
}: AvailabilityRequestProps): JSX.Element {
  const [submitted, setSumitted] = useState(false);
  const [open, setOpen] = useState(false);

  function handleSuccess(): void {
    trackFormSubmit(accommodation, property);
    setSumitted(true);
  }

  function handleFail(): void {
    // TODO => CPT-1732
    window.alert(I18n.t('inquiry_form.fail_notification')); // eslint-disable-line no-alert
  }

  function handleAvailabilityButtonClick(): void {
    const trackingEvent: CPLStartAvailabilityFormEvent = {
      event: 'cpl_start_availability_form',
      parameters: {
        accommodation_id: accommodation.id,
      },
    };
    GoogleTagManagerNg.trackEvent(trackingEvent);
    setOpen(!open);
  }

  if (submitted) {
    return (
      <div className="availability-request-success">
        <h3 className="availability-request-headline">{I18n.t('inquiry_form.thank_you_1')}</h3>
        <p>{I18n.t('inquiry_form.thank_you_2')}</p>
      </div>
    );
  }

  if (open) {
    return (
      <AvailabilityForm
        onSuccess={(): void => handleSuccess()}
        onFail={(): void => handleFail()}
        accommodationId={accommodation.id}
        minDate={minDate}
        bookings={bookings}
      />
    );
  }

  return (
    <button
      className="availability-request-button"
      onClick={handleAvailabilityButtonClick}
      type="button"
    >
      {I18n.t('activerecord.attributes.inquiry_form.inquiry')}
    </button>
  );
}
